module.exports = __webpack_public_path__ + "img/vest-patches.608eebb2.svg";